import $ from 'jquery';

const navbarToggle = (el) => {
  el.toggleClass( 'collapsed' );
  $('.collapse').slideToggle();
  $('.header--mobile').toggleClass('header--mobile--active');
}

$(document).on( 'click', '.navbar-toggler', function() {
  navbarToggle($(this));
});
